import { setUserId } from 'firebase/analytics';
import React, { useContext, useEffect, useState} from 'react';
import { useSearchParams, useLocation, useNavigate} from 'react-router-dom';

import * as FirestoreService from '../services/firestore';
import AppContext from './AppContext'

const ProtectedRoute = ({children}) => {

    const navigate = useNavigate();
    const location = useLocation();     
    const [searchParams, setSearchParams] = useSearchParams();  
    const {user, setUser} = useContext(AppContext); 

    const [showChild,setShowChild] = useState(false)    

    useEffect(()=>{ 
        if(!user){
            FirestoreService.logout(setUser).then(()=>{
                navigate("/login",{
                    state:{
                        "origin":location.pathname,
                        "search":searchParams.toLocaleString()
                    }
                })
            }) 
        }else{
            setShowChild(true)
        }              
    },[])

    return <div className={"flex flex-column flex-grow-1"}>{showChild ? children : null}</div>
}

export default ProtectedRoute;